/* Response Time CSS */

export default theme => ({
    root: {},
    sizeDivider:{
        height:"3px"
    },
    textTittle:{
        textAlign:"center",
        color:"black"
    }

})